<template>
  <div class="tool_wrap flex-colc">
    <!-- <div class="tool_item flex-rowc">
        <span class="iconfont icon-fenleibufen_hengxiangliebiaofenlei"></span>
    </div> -->
    <div class="tool_item flex-rowc" @click="goTop"><span class="iconfont icon-xiangshangjiantou"></span></div>
  </div>
</template>
      
<script>
export default {
  name: "Tool",
  data() {
    return {};
  },
  methods: {
    // 回到顶部
    goTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
      
<style scoped  lang="less">
.tool_wrap {
    position: fixed;
    right: 20px;
    bottom: 14%;
    z-index: 10000;
    .tool_item {
        width: 50px;
        height: 50px;
        background: #fff;
        border-radius: 50%;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        cursor: pointer;
        margin-bottom: 25px;
        .icon-fenleibufen_hengxiangliebiaofenlei {}
        .icon-xiangshangjiantou {

        }
    }
}
</style>
      